export const POLL_ID = {
    MENTAL_HEALTH: 'mental_health',
};
